import {Directive, ElementRef, OnInit, Renderer2} from '@angular/core';

@Directive({
    selector: '[appHideBreadcrumb]'
})
export class HideBreadcrumbsDirective implements OnInit {
    constructor(private elRef: ElementRef, private renderer: Renderer2) {
    }
    ngOnInit() {
        this.renderer.setStyle(this.elRef.nativeElement.querySelector('.breadcrumb-row'), 'display', 'none');
    }
}
